import { inject, Injectable, resource } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
import { Product } from '../components/hof/product/product.component';

@Injectable({
    providedIn: 'root',
})
export class ShopService {
    public lastViewedProduct: Product | null = null;
    private apiService = inject(ApiService);
    config = resource({
        loader: () => firstValueFrom(this.apiService.getShopConfig()),
    });
}
